<template>
  <div class="succes-page">
    <img class="success-qrcode" src="@/assets/img/landingpage/wechat-qrcode.png"/>
    <div class="success-word">
VIPKID数学思维课程对上课设 备有一定的要求，具体要求我们 的课程顾问会与您进行沟通确认。
    </div>
  </div>
</template>
<script>
import sasdk from './sasdkinit'
export default {
  mounted () {
    sasdk.viewsuccess()
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/img/landingpage/spriteout/sprites.scss";
  .succes-page{
    background: url('~@/assets/img/landingpage/success.png') no-repeat;
    width:750px;
    background-size:750px 1624px;
    min-height:1334px;
    height:100vh;
    margin:0 auto;
    position: relative;
  }
  .success-qrcode{
    width:216px;
    height:219px;
    position: absolute;
    top:465px;
    left:132px;
  }
  .success-word{
    position: absolute;
    top:1142px;
    left:143px;
    color:#E77C55;
    font-size:32px;
    font-weight: 400;
    width:468px;
    line-height: 48px;
  }
</style>
